import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Logo } from "@/components/brand";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

export function AuthShell({ title, sub, children, admin }) {
  const nav = useNavigate();
  return (
    <div style={{ minHeight: "100vh", display: "flex" }}>
      <div className="brand-gradient" style={{ flex: 1, display: "none" }} />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }} className="w-full">
        <div style={{ width: "100%", maxWidth: 380 }} className="fade-up">
          <div onClick={() => nav("/")} style={{ cursor: "pointer", marginBottom: 28 }}><Logo /></div>
          <h1 style={{ fontSize: 26, margin: 0 }}>{admin && <Lock size={18} style={{ marginRight: 8, display: "inline" }} />}{title}</h1>
          <p style={{ color: "var(--sub)", marginTop: 6, marginBottom: 24 }}>{sub}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

export function Login({ admin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const u = await login(email, password, admin); nav(u.role === "admin" ? "/admin" : "/dashboard"); }
    catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };

  return (
    <AuthShell admin={admin} title={admin ? "Admin log in" : "Welcome back"} sub={admin ? "Restricted to Clipup admins" : "Log in to your clipper account"}>
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <input className="input-dark" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" required />
        <input className="input-dark" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" required />
        <button className="btn-brand focus-ring" disabled={busy} data-testid="login-submit" style={{ padding: "11px 16px" }}>{busy ? "…" : "Log in"}</button>
      </form>
      {!admin && <p style={{ color: "var(--muted)", fontSize: 13, marginTop: 16 }}>New to Clipup? <span onClick={() => nav("/signup")} style={{ color: "var(--accent-light)", cursor: "pointer" }}>Start clipping</span></p>}
    </AuthShell>
  );
}

export function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await register(email, password, name); nav("/dashboard"); }
    catch (err) { toast.error(apiError(err)); }
    setBusy(false);
  };
  return (
    <AuthShell title="Start clipping" sub="Create your clipper account and get paid per 1K views">
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <input className="input-dark" placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} data-testid="signup-name" required />
        <input className="input-dark" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signup-email" required />
        <input className="input-dark" type="password" placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signup-password" required />
        <button className="btn-brand focus-ring" disabled={busy} data-testid="signup-submit" style={{ padding: "11px 16px" }}>{busy ? "…" : "Create account"}</button>
      </form>
      <p style={{ color: "var(--muted)", fontSize: 13, marginTop: 16 }}>Already have an account? <span onClick={() => nav("/login")} style={{ color: "var(--accent-light)", cursor: "pointer" }}>Log in</span></p>
      <p style={{ color: "var(--muted)", fontSize: 12, marginTop: 18, opacity: .6 }}>Google sign-in — not configured</p>
    </AuthShell>
  );
}
